import React from "react";
import StarRating from "./StarRating";
import { StarRating as StarRatingType } from "../@types";

interface PlanStarRatingListItemProps {
  label: string;
  starRating?: StarRatingType;
  planYear: string;
}

const PlanStarRatingListItem: React.FunctionComponent<PlanStarRatingListItemProps> = props => {
  return (
    <li className="ds-u-display--flex ds-u-flex-wrap--wrap ds-u-md-flex-wrap--nowrap ds-u-justify-content--between">
      <span className="ds-u-margin-bottom--1 ds-u-margin-right--2 ds-u-md-margin-bottom--0">
        {props.label}
      </span>
      <StarRating
        stars={props.starRating}
        includeLabel={false}
        planYear={props.planYear}
      />
    </li>
  );
};

export default PlanStarRatingListItem;
